import { IRoute, IRouteGroup, IRouteNormalized } from '../types';
import NotFound from '../views/404';
import InstructionsView from '../views/instructions';
import LoginView from '../views/login';
import PatientsListView from '../views/patients/list';
import PatientsRegisterView from '../views/patients/register';
import UsersActivateView from '../views/users/activate';
import UsersForgotView from '../views/users/forgot';
import UsersManageClinicAdminView from '../views/users/manage/admin/clinic';
import UsersManageClinicianView from '../views/users/manage/clinician';
import UsersResetView from '../views/users/reset';

// NOTE: nothing special here, nav menus utilize the array order for display
export const routes: IRoute[] = [
  {
    path: '/login',
    Component: LoginView,
    subtitle: 'Login',
    inNav: false,
  },
  {
    path: '/instructions',
    Component: InstructionsView,
    subtitle: 'Instructions For Use & Terms',
    inNav: false,
  },
  {
    path: '/patients/list',
    Component: PatientsListView,
    protected: true,
    titleNav: 'Patient List',
    subtitle: 'Making therapy more efficient',
    group: 'Patients',
  },
  {
    path: '/patients/register',
    Component: PatientsRegisterView,
    protected: true,
    titleNav: 'Register',
    subtitle: 'Register patient with Limbic',
    group: 'Patients',
  },
  {
    path: '/users/forgot',
    Component: UsersForgotView,
    title: 'Reset Account',
    subtitle: 'Forgot password',
    inNav: false,
  },
  {
    path: '/users/reset',
    Component: UsersResetView,
    title: 'Reset Account',
    subtitle: 'Set a new password for your account',
    inNav: false,
  },
  {
    path: '/users/activate',
    Component: UsersActivateView,
    title: 'Activate Account',
    subtitle: 'Set a password for your new account',
    inNav: false,
  },
  {
    path: '/users/manage/admin/clinic',
    Component: UsersManageClinicAdminView,
    protected: true,
    subtitle: 'Manage Clinic Admin users',
    inNav: false,
  },
  {
    path: '/users/manage/clinician',
    Component: UsersManageClinicianView,
    protected: true,
    subtitle: 'Manage Clinicians',
    inNav: false,
  },
  {
    path: '/',
    redirect: '/patients/list',
    inNav: false,
  },
  {
    path: '*',
    Component: NotFound,
    inNav: false,
  },
];

export const navRoutes: IRouteNormalized[] = routes.reduce((a: IRouteNormalized[], c) => {
  // we only want ones that have inNav true or undefined
  // then normalize titleNav
  if (c.inNav === undefined || c.inNav === true)
    return [
      ...a,
      {
        ...c,
        titleNav: c.titleNav || c.title || 'FIX ME!',
      },
    ];
  return a;
}, []);

const groups: string[] = navRoutes.reduce((a: string[], c) => {
  // normalize, might be undefined
  const group = c.group || 'undefined';
  if (a.includes(group)) return a;
  return [...a, group];
}, []);

export const navGroups: IRouteGroup[] = groups.map(group => {
  // have to account for normalized 'undefined' group
  let filtered;

  if (group === 'undefined') filtered = navRoutes.filter(r => !r.group);
  else filtered = navRoutes.filter(r => r.group === group);

  return {
    group,
    routes: filtered,
  };
});
